module.exports = __webpack_public_path__ + "static/media/Gingerbread Man.3e0172a9.jpg";